import { ServiceStatus } from "modules/field-mgmt/tabs/ServiceStatus";
import React from "react";

import {
  ScrollablePane,
  Stack,
  StackItem,
  Text,
  useTheme
} from "@bps/fluent-ui";
import { SectionTitle } from "@components/SectionTitle";
import { FieldDevice } from "@libs/api/gateways/field/field-ops-gateway.dtos";
import { useFieldDevicesDetails } from "@libs/api/gateways/field/field-ops-gateway.hooks";

import { DeploymentDetailTimelineHost } from "./deployment-detail";
import { DeviceOverviewTable, getOverviewItems } from "./DeviceOverviewTable";
import { OverviewBanners } from "./OverviewBanners";

interface FieldDeviceOverviewProps {
  device: FieldDevice;
}

export const FieldDeviceOverview: React.FC<FieldDeviceOverviewProps> = ({
  device
}) => {
  const theme = useTheme();
  const { data: deviceDetails, isLoading } = useFieldDevicesDetails(device.id);

  return (
    <>
      <SectionTitle>Device Overview</SectionTitle>
      <OverviewBanners device={device} />

      <Stack horizontal>
        <ScrollablePane
          styles={{ root: { position: "relative", height: 300, width: "80%" } }}
        >
          <DeviceOverviewTable
            items={getOverviewItems(deviceDetails!, device)}
            isLoading={isLoading}
          />
        </ScrollablePane>

        <Stack
          tokens={{ childrenGap: theme.spacing.m }}
          styles={{
            root: { display: "flex", margin: theme.spacing.s1, width: "20%" }
          }}
        >
          <Stack
            styles={{
              root: {
                display: "block",
                justifyContent: "center"
              }
            }}
          >
            <Text bold>Controller Service</Text>
            <ServiceStatus
              observedTime={deviceDetails?.controllerLastObservedDateTimeUtc}
              runStatusSid={deviceDetails?.controllerRunStatusSid}
              startTime={deviceDetails?.controllerStartDateTimeUtc}
              startup={deviceDetails?.controllerStartup}
              status={deviceDetails?.controllerStatus}
              version={deviceDetails?.controllerVersion}
            />
          </Stack>

          <Stack
            styles={{
              root: {
                display: "block",
                justifyContent: "center"
              }
            }}
          >
            <Text bold>Recovery Agent Service</Text>
            <ServiceStatus
              observedTime={deviceDetails?.recoveryAgentLastObservedDateTimeUtc}
              runStatusSid={deviceDetails?.recoveryAgentRunStatusSid}
              startTime={deviceDetails?.recoveryAgentStartDateTimeUtc}
              startup={deviceDetails?.recoveryAgentStartup}
              status={deviceDetails?.recoveryAgentStatus}
              version={deviceDetails?.recoveryAgentVersion}
            />
          </Stack>
        </Stack>
      </Stack>

      <StackItem>
        <DeploymentDetailTimelineHost fieldDeviceId={device.id} />
      </StackItem>
    </>
  );
};
